import blog01 from '../assets/blog-img/blog01.jpg';
import blog02 from '../assets/blog-img/blog02.jpg';
import blog03 from '../assets/blog-img/blog03.jpg';
import blog04 from '../assets/blog-img/blog04.jpg';
import blog05 from '../assets/blog-img/blog05.jpg';

export const data_main = {id: 1, img: blog01, date:'2022. augusztus 31.', title: 'A csodálatos kerékpár'}

export const data = [    
    {id: 2, img: blog02, date:'2022. augusztus 31.', title: 'Kerékpár kerestetik'},
    {id: 3, img: blog03, date:'2022. augusztus 31.', title: 'Hogyan legyél egyéniség?'},
    {id: 4, img: blog04, date:'2022. augusztus 31.', title: 'A legszebb ajándék'},
    {id: 5, img: blog05, date:'2022. augusztus 31.', title: 'A szépségnek ára van'}
]